import { Platform } from 'react-native';
import * as SecureStore from 'expo-secure-store';
import AsyncStorage from '@react-native-async-storage/async-storage';

// Check if we're running on web
const isWeb = Platform.OS === 'web';

/**
 * Platform-agnostic storage utility
 * Uses SecureStore on native platforms and AsyncStorage on web
 */
export const SecureStorage = {
  /**
   * Get an item from storage
   * @param {string} key - The key to retrieve
   * @returns {Promise<string|null>} - The value or null if not found
   */
  getItemAsync: async (key) => {
    try {
      if (isWeb) {
        return await AsyncStorage.getItem(key);
      } else {
        return await SecureStore.getItemAsync(key);
      }
    } catch (error) {
      console.warn(`Error getting item ${key} from storage:`, error);
      return null;
    }
  },

  /**
   * Set an item in storage
   * @param {string} key - The key to set
   * @param {string} value - The value to store
   * @returns {Promise<void>}
   */
  setItemAsync: async (key, value) => {
    try {
      if (isWeb) {
        await AsyncStorage.setItem(key, value);
      } else {
        await SecureStore.setItemAsync(key, value);
      }
    } catch (error) {
      console.warn(`Error setting item ${key} in storage:`, error);
    }
  },

  /**
   * Remove an item from storage
   * @param {string} key - The key to remove
   * @returns {Promise<void>}
   */
  deleteItemAsync: async (key) => {
    try {
      if (isWeb) {
        await AsyncStorage.removeItem(key);
      } else {
        await SecureStore.deleteItemAsync(key);
      }
    } catch (error) {
      console.warn(`Error removing item ${key} from storage:`, error);
    }
  }
};